import request from '@/utils/request'

let Ma_vehicle_fileApi = {

  /*车辆档案列表*/
  list(data) {
    return request._post('/shop/plus.ma_vehicle_file.Index/index', data);
},
/*添加车辆档案*/
add(data) {
    return request._post('/shop/plus.ma_vehicle_file.Index/add', data);
},
/*修改车辆档案*/
edit(data) {
    return request._post('/shop/plus.ma_vehicle_file.Index/edit', data);
},
/*删除车辆档案*/
del(data) {
    return request._post('/shop/plus.ma_vehicle_file.Index/del', data);
},
/*车辆档案详情*/
detail(data) {
  return request._post('/shop/plus.ma_vehicle_file.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_vehicle_file.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_vehicle_file.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_vehicle_file.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_vehicle_file.Index/export', data);
    },
}
export default Ma_vehicle_fileApi;



// WEBPACK FOOTER //
// ./src/api/ma_vehicle_file.js